import { useUserIntrospectionQuery } from '@common/cache';
import { useEffect } from 'react';
import { useReportStore } from '@store';
import { Report } from './Report.tsx';

export const UsersReport = () => {
  const { setIntrospection } = useReportStore();
  const { data } = useUserIntrospectionQuery();

  useEffect(() => {
    if (data) {
      setIntrospection(data);
    }
  }, [data]);

  return <Report />;
};
